import api from "../../../app-shared/components/utils/http/http-service";
import { MINDEF_AUTH_URL, MINDEF_CLIENT_ID, MINDEF_REDIRECT_URI, MINDEF_RESPONSE_TYPE, MINDEF_SCOPE } from "../../auth/constants/mindef";

class AuthService {
    static login(code) {
        return api.get(`auth/token/${code}`);
    }

    static logout() {
        return api.delete("/auth/token");
    }

    static redirectMindefConnect = () => {
        window.location.href = `${MINDEF_AUTH_URL}?response_type=${MINDEF_RESPONSE_TYPE}&client_id=${MINDEF_CLIENT_ID}&scope=${MINDEF_SCOPE}&redirect_uri=${MINDEF_REDIRECT_URI}`;
    };
}

export default AuthService;
